/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Current AI Chatting feature status
 */
export enum AiChFeatureStatus {
    DISABLED = 'DISABLED',
    INITIALIZING = 'INITIALIZING',
    ENABLED = 'ENABLED',
}
